<template>
  <div class="verification">
    <div class="form">
      <span v-if="isSuccess">{{formText.success}}.</span>
      <span v-if="!isSuccess">{{formText.error}}.</span>
    </div>
  </div>
</template>

<script>
import { api } from '@/api'
export default {
  data () {
    return {
      isSuccess: null
    }
  },
  computed: {
    formText () {
      return {
        success: this.$i18n.t('main.unsubscribeSuccess'),
        error: this.$i18n.t('main.unsubscribeError')
      }
    }
  },
  mounted () {
    this.Unsubscribe()
  },
  methods: {
    async Unsubscribe () {
      const params = {
        token: this.$route.query.token,
        email: this.$route.query.email
      }
      try {
        const res = await api.Unsubscribe(params)
        this.isSuccess = res.data.res === 'ok'
      } catch (err) {
        console.log(err.message)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.verification {
  min-height: 60vh;
  // height: 60vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .form {
    border: 1px solid silver;
    padding: 30px 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px 10px;

    input {
      border: none;
      border-bottom: 1px solid #ddd;
      flex-grow: 1;
      height: 20px;
      line-height: 20px;
      padding-right: 20px;
      font-weight: bold;
      font-size: 13px;
      line-height: 15px;
      letter-spacing: 0.02em;
      color: $text-color;
      max-width: 230px;
    }

    .btn {
      background: #e9786e;
      text-transform: uppercase;
      color: white;
      width: calc(50% - 7px);
      font-weight: bold;
      font-size: 10px;
      text-transform: none;

      &.disabled {
        opacity: 0.7;
      }
    }
  }
}
</style>
